import { useEffect, useState } from "react";
import { Container, FormGroup, Grid, Typography } from "@material-ui/core";

import useLogs from "hooks/logs";
import Api from "lib/api/httpRequestHelper";
import HeaderClientes from "components/_refactor/headers/clients";
import LoadingData from "components/Loading/LoadingData";
import NotFound from "components/Texts/NotFound";
import TableSolicitacaoDevolucao from "./components/TableSolicitacaoDevolucao";
import FormSolicitacaoDialog from "./components/FormSolicitacaoDialog";
import ModalVizualizarSolicitacao from "./components/ModalVizualizarSolicitacao";
import FilterCard from "components/_refactor/filter-card";
import { IsMobile } from "utils/is-mobile";
import { IsMobile900 } from "utils/is-mobile";

import EconomicGroupStoreFields from "components/_refactor/fields/economic-group-store-fields";
import AutoCompleteField from "components/_refactor/fields/autocomplete";
import DateField from "components/_refactor/fields/date";
import InputText from "components/_refactor/text/input";

const statusOptions = [
  { value: "ABERTA", label: "Aberta" },
  { value: "APROVADA", label: "Aprovada" },
  { value: "REJEITADA", label: "Rejeitada" },
];

export default function GerenciamentoSolicitacaoDevolucao() {
  const [fieldsValues, setFieldsValues] = useState({
    idGrupoEconomico: null,
    idPessoa: null,
    cnpj: null,
  });
  const [loadingFields, setLoadingFields] = useState([]);
  const [clearFilters, setClearFilters] = useState(false);

  const [initialDate, setInitialDate] = useState(null);
  const [finalDate, setFinalDate] = useState(null);
  const [dateInvalid, setDateInvalid] = useState(false);
  const [product, setProduct] = useState("");
  const [invoice, setInvoice] = useState("");
  const [status, setStatus] = useState();

  const [solicitationList, setSolicitationList] = useState([]);
  const [searching, setSearching] = useState(false);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [selectedSolicitation, setSelectedSolicitation] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogType, setDialogType] = useState("");
  const [openVisibilityModal, setOpenVisibilityModal] = useState(false);

  const isMobile900 = IsMobile900();
  const isMobile = IsMobile();

  const itemXSResponsive = isMobile ? 12 : isMobile900 ? 6 : 3;

  const itemXSResponsiveXS = isMobile ? 12 : isMobile900 ? 6 : 2;
  const { setLocalStorageApiProblem } = useLogs();

  const isLoadingFields = loadingFields.length > 0;

  const handleVerifyDate = () => {
    if (initialDate && finalDate) {
      if (initialDate > finalDate) {
        setDateInvalid(true);
      } else {
        setDateInvalid(false);
      }
    }
  };

  const handleClearFinalDate = () => {
    document.getElementById("#buttonClearFinalDate").click();
  };

  const handleClearInitialDate = () => {
    document.getElementById("#buttonClearInitialDate").click();
  };

  const handleClearFilters = () => {
    setClearFilters(true);
    setInitialDate(null);
    setFinalDate(null);
    handleClearInitialDate();
    handleClearFinalDate();
    setProduct("");
    setInvoice("");
    setStatus(null);
    setTimeout(() => {
      setClearFilters(false);
    }, 100);
  };

  const handleSearch = async () => {
    setSearching(true);

    try {
      const res = await Api.get(
        "list-request-reason",
        "trocasDevolucoes",
        "?page=" +
          (page === 0 ? page : page - 1) +
          "&pageSize=25" +
          (fieldsValues.idGrupoEconomico
            ? "&idGrupoEconomico=" + fieldsValues.idGrupoEconomico
            : "") +
          (fieldsValues.idPessoa ? "&idPessoa=" + fieldsValues.idPessoa : "") +
          (fieldsValues.cnpj ? "&cnpj=" + fieldsValues.cnpj : "") +
          (initialDate ? "&dtIni=" + initialDate : "") +
          (finalDate ? "&dtFim=" + finalDate : "") +
          (product ? "&idProduto=" + product : "") +
          (invoice ? "&numeroNota=" + invoice : "") +
          (status ? "&statusSolicitacao=" + status : ""),
        true
      );

      const pages = Math.ceil(res.Result.TotalRegistros / 25);
      setTotalPages(pages);
      setSolicitationList(res.Result.ListSolicitacao);
    } catch (e) {
      setLocalStorageApiProblem({
        idMenuAccess: "10",
        screen: "Solcitar Devolução",
        problem: `Erro na chamada do endpoint list-request-reason - ${e}`,
      });
    } finally {
      setSearching(false);
    }
  };

  useEffect(() => {
    if (page > 0) {
      handleSearch();
    }
  }, [page]);

  useEffect(() => {
    handleSearch();
  }, []);

  useEffect(() => {
    handleVerifyDate();
  }, [initialDate, finalDate]);

  return (
    <div>
      <HeaderClientes
        section="Gestão de solicitação de devolução"
        subsection="Gerenciamento"
      />
      <Container style={{ marginTop: "-4rem" }} maxWidth={false}>
        <FilterCard
          handleSearch={handleSearch}
          disabled={searching}
          searching={isLoadingFields || searching}
          handleClearFilters={handleClearFilters}
          bottonInfo={
            <>
              {dateInvalid && (
                <Typography
                  variant="h5"
                  component="h5"
                  style={{ color: "grey", marginTop: "1rem" }}
                >
                  <i
                    className="fa fa-exclamation-circle"
                    aria-hidden="true"
                    style={{
                      fontSize: "1rem",
                      marginRight: "0.5rem",
                    }}
                  />{" "}
                  A data final é menor que a data inicial.
                </Typography>
              )}
            </>
          }
        >
          <EconomicGroupStoreFields
            onFieldsChange={setFieldsValues}
            onFieldsLoad={setLoadingFields}
            disableAll={searching}
            clearFilters={clearFilters}
          />

          <Grid item xs={itemXSResponsiveXS}>
            <FormGroup data-tut="reactour__step4">
              <DateField
                label="Data Início"
                disabled={isLoadingFields}
                value={initialDate}
                onChange={(value) => {
                  setInitialDate(value);
                }}
                required={false}
              />
            </FormGroup>
          </Grid>

          <Grid item xs={itemXSResponsiveXS}>
            <FormGroup data-tut="reactour__step5">
              <DateField
                label="Data Fim"
                disabled={isLoadingFields}
                value={finalDate}
                onChange={(value) => {
                  setFinalDate(value);
                }}
                required={false}
              />
            </FormGroup>
          </Grid>

          <Grid item xs={itemXSResponsive}>
            <InputText
              label="Código Produto"
              value={product}
              onChange={(e) => {
                setProduct(e.target.value.slice(0, 200));
              }}
              disabled={isLoadingFields}
            />
          </Grid>

          <Grid item xs={itemXSResponsive}>
            <InputText
              label="Nota Fiscal"
              value={invoice}
              onChange={(e) => {
                setInvoice(e.target.value.slice(0, 10));
              }}
              disabled={isLoadingFields}
            />
          </Grid>

          <Grid item xs={itemXSResponsiveXS}>
            <AutoCompleteField
              label="Status"
              onChange={(value) => {
                setStatus(value?.value);
              }}
              options={statusOptions}
              loading={isLoadingFields}
              value={statusOptions.find((s) => s.value === status) ?? null}
              optionLabelKey="label"
              optionIdKey="value"
            />
          </Grid>
        </FilterCard>

        {searching ? (
          <Grid item xs={12}>
            <LoadingData
              searching={searching}
              label="Buscando dados..."
              hiddenIcon={true}
            />
          </Grid>
        ) : (
          <Grid item xs={12}>
            {solicitationList.length > 0 ? (
              <TableSolicitacaoDevolucao
                solicitacoesDevolucao={solicitationList}
                onApprove={() => {
                  setOpenDialog(true);
                  setDialogType("accept");
                }}
                onReject={() => {
                  setOpenDialog(true);
                  setDialogType("reject");
                }}
                setPage={setPage}
                totalPages={totalPages}
                setSelectedSolicitation={setSelectedSolicitation}
                setOpenVisibilityModal={setOpenVisibilityModal}
              />
            ) : (
              <NotFound
                title={"Desculpa"}
                subtitle={"Sua busca não encontrou resultados"}
              />
            )}
          </Grid>
        )}

        {openDialog && (
          <FormSolicitacaoDialog
            type={dialogType}
            open
            onClose={() => {
              setOpenDialog(false);
              setDialogType("");
            }}
            solicitacao={selectedSolicitation}
            handleSearch={handleSearch}
          />
        )}

        {openVisibilityModal && (
          <ModalVizualizarSolicitacao
            solicitacao={selectedSolicitation}
            handleClose={() => setOpenVisibilityModal(false)}
          />
        )}
      </Container>
    </div>
  );
}
